<template>
    <div>
        <div class="option-title" v-if="!showPlaneMode">Envio de Fotos</div>
        <div class="option-title-edit" v-else>
            <ul>
                <li><strong>Envio de Fotos</strong></li>
            </ul>
        </div>
        <div class="frame-option" :class="[!showPlaneMode ? 'disable-styles px-4' : 'edit-styles']">
            <li>
                <p class="option-subtitle">Posso enviar fotos próprias para a minha loja?</p>
                <p>
                    Essa funcionalidade será liberada para lojas que atingirem, no mínimo, R$
                    2.000,00 em vendas. Para todos os lojistas, temos imagens padronizadas que são
                    criadas pelo nosso sistema automaticamente, através da base do produto e sua
                    arte. ;)
                </p>
            </li>

            <li>
                <p class="option-subtitle">Por quais motivos minhas fotos podem ser reprovadas?</p>
                <p>
                    Para que suas imagens sejam aprovadas é preciso que elas estejam de acordo com
                    as regras e instruções de envio. Assim como na aprovação de estampas, levamos em
                    conta alguns critérios, tais como:
                </p>
                <p>
                    <u>Direito de Uso de Imagem</u>: caso as fotos não sejam de sua autoria é
                    necessário que você possua o
                    <strong>Direito Autoral ou Direito de Uso da Imagem.</strong>
                </p>
                <p>
                    Fotos de figuras públicas ou pertencentes a outras marcas não serão permitidas.
                    Mockups gratuitos ou com autorização de uso comercial podem ser utilizados,
                    desde que contenham aviso sobre
                    <i>“imagem ou reprodução meramente ilustrativa”</i>
                </p>
                <p>
                    <u>Termos de Uso</u>: não aceitamos nada que seja
                    <strong>ofensivo ou abusivo em qualquer esfera</strong>, tampouco conteúdo
                    explícito. Caso a imagem enviada não esteja de acordo com os termos de uso de
                    Uma Penca, aceitos no momento de cadastro na plataforma, a mesma será
                    automaticamente reprovada. Ao aceitar estes termos, o usuário assegura respeitar
                    <strong>direitos autorais e leis de direito sobre imagem</strong>, além de
                    garantir
                    <strong
                        >não agredir direitos humanos ou afirmar qualquer tipo de
                        preconceito</strong
                    >, sob pena de banimento definitivo da plataforma e de responder judicialmente
                    pelos crimes.
                </p>
                <p>
                    <u>Qualidade de Imagem</u>: para realizar o upload da sua imagem na plataforma,
                    o arquivo deve estar na resolução de <strong>1800px X 2700 px</strong>, possuir
                    tamanho máximo de 15 MB e <strong>formato JPEG</strong>. Siga as instruções para
                    que não haja nenhum tipo de problema na hora de cadastrar o seu produto. Caso
                    sua imagem não seja aprovada, você receberá uma notificação automática por
                    e-mail com o motivo da reprovação. Por isso, fique de olho na sua caixa de
                    entrada.
                </p>
            </li>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PhotoTerms',

        props: {
            showPlaneMode: {
                default: false,
                type: Boolean,
            },
        },
    };
</script>
